import { CSSProperties, ReactNode } from 'react';
import {
  Popper as MUIPopper,
  PopperProps as MUIPopperProps,
} from '@mui/material';

type AtomMUIProps = {
  open: boolean;
  children?: ReactNode;
  anchorEl?: Element;
  disablePortal?: boolean;
  keepMounted?: boolean;
  onClose?: () => void;
  placement?: any;
  popperOptions?: any;
  modifiers?: any;
  /** Inline styles applied to the popper root (e.g. z-index, width). */
  style?: CSSProperties;
};

export type PopperProps = AtomMUIProps;

export const Popper = (props: PopperProps) => {
  const MUIProps: MUIPopperProps = props;

  return <MUIPopper {...MUIProps} />;
};

export default Popper;
